// extracted by mini-css-extract-plugin
module.exports = {"agreementCard":"agreementCard--1vCKk","agreementRequiredText":"agreementRequiredText--3Md0e","cookieTextSection":"cookieTextSection--3jdCB"};